<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/ajinomoto/report'" index="2" icon="description">
        Report
      </vs-sidebar-item>
      <vs-sidebar-item
        :to="'/OverviewAjinomotoDashbooard'"
        icon="corporate_fare"
      >
        Overview Dashboard
      </vs-sidebar-item>

      <vs-sidebar-group title="Dashboard" open >
        <vs-sidebar-item v-for="(tr, indextr) in users_item" v-if="tr.users.includes(username)" :to="tr.path" icon="corporate_fare">
          {{ tr.name }}
        </vs-sidebar-item>
        <!-- <vs-sidebar-item :to="'/Machinelist/UM'" icon="corporate_fare">
          UM Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/SP1'" icon="corporate_fare">
          SP1 Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/SP2'" icon="corporate_fare">
          SP2 Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/SP3'" icon="corporate_fare">
          SP3 Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/JP'" icon="corporate_fare">
          JP Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/UM/MN-MDB_EX1'" icon="corporate_fare">
          EX1 Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/UM/MN-MDB_EX2'" icon="corporate_fare">
          EX2 Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/UM/MN-PWH'" icon="corporate_fare">
          WH Building
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/Machinelist/SP2/SP2-GA'" icon="corporate_fare">
          GA Building
        </vs-sidebar-item> -->
      </vs-sidebar-group>

      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Setting">
        <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
          Network
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer">
      <div class="footer-sidebar center">
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="@/assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
    </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      users_item: [
        {
          id: 1,
          name: 'UM Building',
          path: '/Machinelist/UM',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut']
        },
        {
          id: 2,
          name: 'SP1 Building',
          path: '/Machinelist/SP1',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-sp1']
        },
        {
          id: 3,
          name: 'SP2 Building',
          path: '/Machinelist/SP2',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-sp2', 'ajtnk-dc']
        },
        {
          id: 4,
          name: 'SP3 Building',
          path: '/Machinelist/SP3',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-sp3']
        },
        {
          id: 5,
          name: 'JP Building',
          path: '/Machinelist/JP',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-jp']
        },
        {
          id: 6,
          name: 'EX1 Building',
          path: '/Machinelist/UM/MN-MDB_EX1',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-ex']
        },
        {
          id: 7,
          name: 'EX2 Building',
          path: '/Machinelist/UM/MN-MDB_EX2',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-ex']
        },
        {
          id: 8,
          name: 'WH Building',
          path: '/Machinelist/UM/MN-PWH',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut']
        },
        {
          id: 9,
          name: 'GA Building',
          path: '/Machinelist/SP2/SP2-GA',
          users: ['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut', 'ajtnk-gc']
        },
        {
          id: 10,
          name: 'MN-PWH Building',
          path: '/Machinelist/UM/MN-PWH',
          users: ['ajinomotodemo', 'ajtnk-ic']
        },
        {
          id: 11,
          name: 'SP1-CWH Building',
          path: '/Machinelist/SP1/SP1-CWH',
          users: ['ajinomotodemo', 'ajtnk-ic']
        },
        {
          id: 12,
          name: 'SP2-TFTC Building',
          path: '/Machinelist/SP2/SP2-TFTC',
          users: ['ajinomotodemo', 'ajtnk-tftc']
        },
      ]
    };
  },
  created() {
    this.username = this.$session.get("username");
  },
};
</script>

<style>
</style>